<template>
  <div class="container">
    <div class="columns">
      <div class="column settings">
        <h1 class="title is-4">Inställningar</h1>

        <hr class="solid" />
        
        <h1 class="title is-5">Företagsnamn</h1>

        <textarea class="textarea" v-model="nameText" rows="1"></textarea>

        <hr class="solid" />

        <h1 class="title is-5">Text på framsida</h1>

        <textarea class="textarea" v-model="frontText" rows="7"></textarea>

        <hr class="solid" />

        <h1 class="title is-5">Text på bokningsinfo</h1>

        <textarea class="textarea" v-model="bookText" rows="7"></textarea>

        <hr class="solid" />

        <h1 class="title is-5">Automatiskt mail-svar</h1>

        <textarea class="textarea" v-model="mailResponse" rows="7"></textarea>

        <hr class="solid" />

        <h1 class="title is-5">Andra inställningar</h1>

        <div class="columns">
            <div class="column is-5">
              Visa pris
              <br />
              Seglarskola för barn (visar utökade fält vid anmälan)
            </div>
            <div class="column">
              <input v-model="showPrice" type="checkbox" />
              <br />
              <input v-model="extendedFields" type="checkbox" />
            </div>
          </div>

        <hr class="solid" v-if="false"/>

        <h1 class="title is-5" v-if="false">Betalningsalternativ</h1>

        <div class="payment" v-for="method in paymentMethods" :key="method._id">
          <h1 class="title is-6">{{ method.paymentName }}</h1>

          <div class="columns">
            <div class="column is-1">
              Aktiverad
              Beskrivning
            </div>
            <div class="column">
              <input v-model="method.enabled" type="checkbox" />
              <input v-model="method.description" class="input" type="text" placeholder="Text input">
            </div>
          </div>
        </div>

        <hr class="solid" />

        <button class="button is-primary" @click="update">
          Spara Inställningar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request.js";

export default {
  name: "Settings",
  data() {
    return {
      frontText: null,
      bookText: null,
      nameText: null,
      paymentMethods: null,
      showPrice: null,
      extendedFields: null,
      mailResponse: null,
    };
  },
  methods: {
    getFrontText: function () {
      axios.get("/api/texts/front").then((response) => {
        this.frontText = response.data;
      });
    },
    updateFrontText: function () {
      axios.put("/api/texts/front", { text: this.frontText });
    },
    getBookText: function () {
      axios.get("/api/texts/book").then((response) => {
        this.bookText = response.data;
      });
    },
    getMailText: function () {
      axios.get("/api/texts/mail").then((response) => {
        this.mailResponse = response.data;
      });
    },
    updateMailText: function () {
      axios.put("/api/texts/mail", { text: this.mailResponse });
    },
    updateBookText: function () {
      axios.put("/api/texts/book", { text: this.bookText });
    },
    getNameText: function () {
      axios.get("/api/texts/name").then((response) => {
        this.nameText = response.data;
      });
    },
    getSettings: function () {
      axios.get("/api/settings/showprice").then((response) => {
        this.showPrice = response.data;
      });
      axios.get("/api/settings/extendedfields").then((response) => {
        this.extendedFields = response.data;
      });
    },
    updateNameText: function () {
      console.log(this.nameText)
      axios.put("/api/texts/name", { text: this.nameText });
    },
    getPaymentMethods: function () {
      axios.get("/api/payment_methods").then((response) => {
        this.paymentMethods = response.data;
      });
    },
    updatePaymentMethods: function () {
      for(var i = 0; i < this.paymentMethods.length; i++){
        var method = this.paymentMethods[i]
        axios.put("/api/payment_methods/" + method._id, method);
      }
    },
    updateSettings: function () {
      axios.put("/api/settings/showprice", {'enabled' : this.showPrice});
      axios.put("/api/settings/extendedfields", {'enabled' : this.extendedFields});
    },
    update: function () {
      this.updateFrontText();
      this.updateBookText();
      this.updateNameText();
      this.updateSettings();
      this.updateMailText();
      this.updatePaymentMethods();
    },
  },
  created() {
    this.getBookText();
    this.getFrontText();
    this.getNameText();
    this.getSettings();
    this.getMailText();
  },
};
</script>

<style scoped>
.settings {
  text-align: left;
}

.payment {
  margin-bottom: 20px;
}

.is-one {
  text-align: right;
}

.container {
  padding: 15px;
}

</style>
